/**
 * Spaja Redux user i localStorage profile da polje package (i ostalo) ne ostane zastarelo.
 */
export function mergeAuthProfile(reduxUser) {
  let fromLs = null;
  if (typeof window !== 'undefined') {
    try {
      const profileStr = localStorage.getItem('profile');
      if (profileStr) fromLs = JSON.parse(profileStr);
    } catch {
      fromLs = null;
    }
  }

  const pickPackage = (a, b) => {
    const na = Number(a);
    const nb = Number(b);
    const va = Number.isFinite(na) && na >= 1 && na <= 5 ? na : null;
    const vb = Number.isFinite(nb) && nb >= 1 && nb <= 5 ? nb : null;
    if (va != null && vb != null) return Math.max(va, vb);
    return va ?? vb ?? undefined;
  };

  if (reduxUser?.result && fromLs?.result) {
    const r = reduxUser.result;
    const l = fromLs.result;
    const pkg = pickPackage(r.package, l.package);
    return {
      ...fromLs,
      ...reduxUser,
      token: reduxUser.token || fromLs.token,
      result: {
        ...l,
        ...r,
        ...(pkg !== undefined ? { package: pkg } : {}),
      },
    };
  }

  if (reduxUser?.result) return reduxUser;
  if (fromLs?.result) return fromLs;
  return reduxUser;
}
